/* eslint-disable */

export default {
  status: 200,
  data: {
    status: true,
    data: {
      images: {
        id: 172631,
        background: [],
        cover_page: [],
        cover_video: [],
        images_page: []
      },
      email_owner: "dpatino@itereo.travel",
      itineraries: [
        {
          id: 4771712,
          days: [
            {
              meals: [
                {
                  mealsday: "Welcome Dinner"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps.(Breakfast)"
                }
              ],
              duration: 1,
              idimagen: 8937,
              startday: 1,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "Sandymount Hotel Dublin",
              line_breaks_number: 0,
              startdate: "2021-09-30",
              enddate: "2021-10-01",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free Time in Seville.",
              textday: [
                {
                  textday:
                    "Enjoy a relaxed start and a day to relax, shop or continue exploring this fascinating city at your own pace. Our suggestion is to join an Optional Experience to the ancient city of C&oacute;rdoba, where you will visit the magnificent Mezquita, see the old Jewish Quarter, and enjoy some free time to shop or explore as you wish. Visit Cristina Heeren Foundation, a beneficiary of a TreadRight Foundation grant. This private dance school is dedicated to promoting the conservation of flamenco and supports young enthusiasts from all over the world with a special focus on new talent from the Andalusian region. Feel the passion behind the choreography as you put your rhythm to the test during a dance lesson before witnessing emotions come to life in a flamenco performance. With some free time for dinner, head next door to Triana market and stroll through the many colourful stalls where vendors are selling tapas made from fresh, local produce. Why not grab yourself a refreshing sangria for a cheers to your new found dancing feet?"
                }
              ],
              duration: 1,
              idimagen: 9807,
              startday: 2,
              locations: [
                {
                  code: "ES-SVQ",
                  name: "Seville - Spain",
                  order: 1,
                  location_latitude: 37.38788,
                  location_longitude: -6.00197
                }
              ],
              accommodation: "Hotel Kilkenny",
              line_breaks_number: 0,
              startdate: "2021-10-01",
              enddate: "2021-10-02",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/350x240/Seville3.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1200x725/Seville3.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1600x900/Seville3.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Dinner with Wine"
                },
                {
                  mealsday: "Dinner with Wine/Beer"
                }
              ],
              title: "Welcome to Madrid.",
              textday: [
                {
                  textday:
                    "Your airport transfer departs Madrid airport for your hotel at 09:00, 11:30, 13:30 or 16:00. The rest of the day is at leisure to begin to get to know this stylish city. At 18:00, join your Travel Director for your Welcome Dinner at a local restaurant and enjoy the opportunity to get to know your fellow travellers over a delightful evening of good food and wine. During your time in Madrid you will travel along the main historical areas in the Capital of Spain known as Madrid of the Bourbons. Your drive will take you through the Old Quarter discovering the origins of the city."
                }
              ],
              duration: 1,
              idimagen: 5344,
              startday: 3,
              locations: [
                {
                  code: "ES-MAD",
                  name: "Madrid - Spain",
                  order: 1,
                  location_latitude: 40.41956,
                  location_longitude: -3.69196
                }
              ],
              accommodation: "The Parkavon Hotel Killarney",
              line_breaks_number: 0,
              startdate: "2021-10-02",
              enddate: "2021-10-03",
              url_image: "",
              url_image_1200_725: "",
              url_image_1600_900: "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps."
                }
              ],
              duration: 0,
              idimagen: 8938,
              startday: 4,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-03",
              enddate: "2021-10-03",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets_1.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets_1.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets_1.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps.(Breakfast)"
                }
              ],
              duration: 1,
              idimagen: 8937,
              startday: 1,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "Flannery's Hotel Galway",
              line_breaks_number: 0,
              startdate: "2021-09-30",
              enddate: "2021-10-01",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Lunch"
                }
              ],
              title: "Free Time in Seville.",
              textday: [
                {
                  textday:
                    "Enjoy a relaxed start and a day to relax, shop or continue exploring this fascinating city at your own pace. Our suggestion is to join an Optional Experience to the ancient city of C&oacute;rdoba, where you will visit the magnificent Mezquita, see the old Jewish Quarter, and enjoy some free time to shop or explore as you wish. Visit Cristina Heeren Foundation, a beneficiary of a TreadRight Foundation grant. This private dance school is dedicated to promoting the conservation of flamenco and supports young enthusiasts from all over the world with a special focus on new talent from the Andalusian region. Feel the passion behind the choreography as you put your rhythm to the test during a dance lesson before witnessing emotions come to life in a flamenco performance. With some free time for dinner, head next door to Triana market and stroll through the many colourful stalls where vendors are selling tapas made from fresh, local produce. Why not grab yourself a refreshing sangria for a cheers to your new found dancing feet?"
                }
              ],
              duration: 1,
              idimagen: 9807,
              startday: 2,
              locations: [
                {
                  code: "ES-SVQ",
                  name: "Seville - Spain",
                  order: 1,
                  location_latitude: 37.38788,
                  location_longitude: -6.00197
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-01",
              enddate: "2021-10-02",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/350x240/Seville3.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1200x725/Seville3.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1600x900/Seville3.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Farewell Dinner with Wine/Beer"
                }
              ],
              title: "Welcome to Madrid.",
              textday: [
                {
                  textday:
                    "Your airport transfer departs Madrid airport for your hotel at 09:00, 11:30, 13:30 or 16:00. The rest of the day is at leisure to begin to get to know this stylish city. At 18:00, join your Travel Director for your Welcome Dinner at a local restaurant and enjoy the opportunity to get to know your fellow travellers over a delightful evening of good food and wine. During your time in Madrid you will travel along the main historical areas in the Capital of Spain known as Madrid of the Bourbons. Your drive will take you through the Old Quarter discovering the origins of the city."
                }
              ],
              duration: 1,
              idimagen: 5344,
              startday: 3,
              locations: [
                {
                  code: "ES-MAD",
                  name: "Madrid - Spain",
                  order: 1,
                  location_latitude: 40.41956,
                  location_longitude: -3.69196
                }
              ],
              accommodation: "Sandymount Hotel",
              line_breaks_number: 0,
              startdate: "2021-10-02",
              enddate: "2021-10-03",
              url_image: "",
              url_image_1200_725: "",
              url_image_1600_900: "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps."
                }
              ],
              duration: 0,
              idimagen: 8938,
              startday: 4,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-03",
              enddate: "2021-10-03",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets_1.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets_1.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets_1.jpeg",
              image_duplicated: false
            }
          ],
          endplace: null,
          triptype: "",
          tourstyle: "",
          book_group: "",
          highlights: [],
          startplace: null,
          description: "",
          toitinerary: "2021-10-03",
          fromitinerary: "2021-09-30",
          whatsincluded: [],
          itinerary_code: "#TESTIV3434",
          notesitinerary: null,
          onlinebookable: 0,
          sellingregions: [
            {
              id: 244,
              order: 1
            }
          ],
          titleitinerary: "IV Test",
          itinerary_theme: 0,
          letter_itinerary: "",
          terms_conditions: "",
          whatsnotincluded: [],
          count_days_nights: {
            days: 4,
            nights: 3
          },
          locations_visited: [
            {
              name: "Germany"
            },
            {
              name: "Spain"
            }
          ],
          pricing_itinerary: "",
          approval_signature: null,
          itinerary_format_type: 27,
          itinerary_source_type: 34920,
          itinerary_tracking_id: "",
          locations_visited_coo: [
            {
              id: "4771718",
              lat: "48.15061268008",
              lng: "11.548278589125",
              name: "Munich ",
              idloc: "32417",
              duration: 1,
              startday: "1",
              lat_temp: "48.15061268008",
              lng_temp: "11.548278589125"
            },
            {
              id: "4771722",
              lat: "37.38788",
              lng: "-6.00197",
              name: "Seville",
              idloc: "41360",
              duration: 1,
              startday: "2"
            },
            {
              id: "4771726",
              lat: "40.41956",
              lng: "-3.69196",
              name: "Madrid",
              idloc: "39938",
              duration: 1,
              startday: "3"
            },
            {
              id: "4771730",
              lat: "48.13642",
              lng: "11.57755",
              name: "Munich ",
              idloc: "32417",
              duration: 0,
              startday: "4"
            }
          ],
          itinerary_source_type_text: "ITP-GUEST"
        }
      ],
      request_form: {
        budget: "",
        foc_places: "",
        group_photo: 0,
        price_break: "",
        airport_arrive: "",
        hotel_standard: 0,
        quote_deadline: "",
        airport_departure: "",
        repeat_guest_gift: 0,
        birthday_allowance: 0,
        td_offer_optionals: 0,
        prebookings_required: 0,
        percentage_commission: 0,
        additional_information: "",
        including_local_guides: 0,
        difficult_dates_checked: 0,
        flourishes_local_treats: 0,
        properties_request_form: {
          id_guests: 0,
          id_supplier: 0,
          id_additional_doc: 0,
          id_stage_supplier: 23,
          id_stage_supplier_old: 23
        },
        gratuities_for_td_driver: 0
      },
      client_details: {
        account_name: "",
        contact_name: "",
        phone_number: "",
        account_email: "",
        account_address: "",
        properties_client: {
          id_type_client: 0
        }
      },
      departure_date: "2021-09-30",
      lastname_owner: "Patiño Panduro",
      firstname_owner: "Dariana",
      selling_regions: [
        {
          id: 244,
          order: 0
        }
      ],
      opportunity_name: "IV Test",
      reference_number: "#TESTIV3434",
      template_content: null,
      guest_documentation: {
        id: 96148,
        images: {
          id: 96149,
          background: [
            {
              id: 189369,
              asset_id:	20572,
              url_image:	"https://dkbr8tla2pux3.cloudfront.net/images/assets/images/EG/EG-CAI/1560x790/Giza Day.jpeg"
            }
          ],
          cover_page: [],
          cover_video: [],
          images_page: []
        },
        hotel_list:
          '<div class="table"><table><tbody><tr><td><strong>Hotel Palazzo Dei Priori Srl. Siena</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr><tr><td><strong>Hotel Name</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr><tr><td><strong>Hotel Name</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr><tr><td><strong>Hotel Name</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr></tbody></table></div><p><i>Sample</i> </p>',
        introduction:"<p>Dear <strong>XXXXX</strong></p>\n\n<p>Welcome to the art of traveling in style. At Insight Vacations we have been creating magical travel experiences for over 40 years, and we are pleased to offer you this proposal for your upcoming Custom Group on the <strong>XXXXX</strong> departing on the<strong> XXXX.</strong></p>\n\n<p><strong>*Additional notes pertaining to the trip here*</strong></p>\n\n<p>As you have exclusive use of the coach, should you wish to make any changes to the itinerary or inclusions, please let us know and we can tailor the trip to the groups desires.</p>\n\n<p><strong>No hotel space has been booked at this stage, therefore hotels listed in this quotation are to be used as a guide only and subject to change depending on availability at time of reservation. Should the quoted hotel be unavailable we will endeavour to book a similar standard property within the quoted budget.</strong></p>\n\n<p>Prices are based on (<strong>firm 2021 </strong>rates/ <strong>OR</strong> <strong>based on 2021 rates to be used as a guide only, therefore quote will be repriced mid year when firm 2022 pricing is released)</strong>. If accommodation dates fall over any conventions or large scale events, or if particular hotel is required to be contracted, a supplement may be applicable. In these cases, we will notify you when this becomes known to discuss options available to your group. Group hotel space works on a first come first served basis, therefore should you wish to proceed with the proposal we encourage you to let us know as soon as possible so we can commence working on hotel reservations! This process can take some time but we will ensure you are kept up to date. Itinerary maybe subject to change also in some extreme cases where, availability is an issue in a localation quoted.</p>\n\n<p>In this new, fast changing COVID-19 era, we have implemented elevated hygiene and distancing practices to meet new requirements put forth by local governments and health authorities, including the World Health Organization (WHO). These details can be found on our website https://www.insightvacations.com/us/the-insight-difference/well-being. As we adapt to this new world we continue to execute numerous new measures throughout our various guest experiences with the best care and service  possible, to ensure optimum health and well-being for our guests and our team. These new protocols will be adapted and adjusted as needed, in a timely manner, as governments define and introduce what will be required in each country.</p>\n\n<p>As these directives become known and if your group is affected, we will work with you to achieve the best outcome keeping the well-being and peace of mind of our guests as our top priority. Considering the fluidity of situation, the pricing and itinerary, including sightseeing venues, hotels and restaurants are subject to change upon government regulatory changes.</p>\n\n<p>Please read the quotation carefully, and full terms and conditions are also provided here for your reference.</p>\n\n<p>Should you wish to proceed, please process a $500 refundable deposit to us and we will in turn commence making reservations for your group.</p>\n\n<p>Please do not hesitate to contact us for any queries you may have, we are here to help! We look forward to the opportunity of working with you.</p>\n\n<p>Kind regards</p>\n\n<p><strong>XXXXX (insert signature with cta here)</strong></p>\n",
        optional_experience:
          '<div class="table"><table><tbody><tr><td><strong>Spectacular Oia Village Perched On The Caldera Rim</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr></tbody></table></div><p><i>Sample</i></p>'
      },
      properties_opportunity: {
        id: 96139,
        id_brand: 15,
        id_opportunity_status: 5,
        id_opportunity_export_type: 18
      },
      opportunity_details: {
        id_brand: 15,
        departure_date: "2021-09-30",
        opportunity_name: "IV Test",
        reference_number: "#TESTIV3434",
        regions: [
          {
            id: 244,
            order: 0
          }
        ],
        types: 18
      },
      consumer_section: {
        images: {
          background: [],
          cover_page: [],
          cover_video: [],
          images_page: []
        }
      },
      created_at: "2021-12-29"
    },
    template: "luxury-gold",
    hash: "1beY5jg9_GE5FJTUYr_1V-eaUAoPkPeZOBVFDFlwXhE"
  }
};
